export enum AccountSettingsTab {
    Alerts = 0,
    RegionTime = 1,
    Units = 2,
    Security = 3,
}

export enum AccountSettingsView {
    Settings = 0,
    SmsOptIn = 1,
    SmsVerify = 2,
    TwoFactor = 3,
    ChangePassword = 4,
}
